import React from "react";

const StateLines = ({totalLineCount, greenLineCount}) => {
    const getLines = () => {
        let lines = []
        for (let i = 0; i < totalLineCount; i++) {
            lines.push(<div className={`${i < greenLineCount ? "greenLine" : "ashLine"}`}></div>);
        }
        return lines;
    }
    return (
        <div className="d-flex flex-row stateLines">
            {getLines()}
        </div>
    )
}

export default StateLines;
